
angular.module('app')

.directive('well', function ($timeout)
{
    function link (scope, element, attributes, component)
    {
        component.setFocusRequestHandler(function ()
        {
            $timeout(function ()
            {
                scope.$broadcast('component:request-focus', scope.model.nested);
            });
        });
    }

    return {
        replace: true,
        restrict: 'A',
        require: '^component',
        templateUrl: 'modules/programme/editor-components/well/well.html',
        link: link
    };
});
